import ApplicationConfiguration from '@lib/ApplicationConfiguration'
import {default as ReactModal} from 'react-modal'

export class Application {
    constructor(options) {
        this.options = new ApplicationConfiguration(options)
        Application.instance = this
    }

    /**
     * @return {ApplicationConfiguration}
     */
    getOptions() {
        return this.options
    }

    /**
     * @return {Application}
     */
    static getInstance() {
        return Application.instance
    }
}

export default class CTTApplication extends Application {
    static initialize(options) {
        return new CTTApplication(options)
    }

    static setTwsVisibility(value) {
        window.localStorage.setItem("twsVisibility", value);
    }

    static getTwsVisibility() {
        var value = window.localStorage.getItem("twsVisibility");
        if (value == null) {
            this.setTwsVisibility(false);
            return false;
        }
        return value;
    }
}

window.CTTApplication = CTTApplication
window.onload = () => {
    ReactModal.setAppElement('#app');
};